import React from "react";
import styled from "styled-components";
import Schedule from "../Schedule/Schedule";

const Main = styled.div`
  padding-top: 52px;
  margin-bottom: 52px;
`;

export default function () {
  return (
    <Main>
      <Schedule />
    </Main>
  );
}
